import type { Distance } from "@pdfking/math"
import { Scale } from "@pdfking/math"

/** The size a weekday's name or initial is set in beside days numbered in
 * `font`: smaller, so the days read first. */
export const WeekdayFont = (font: Distance): Distance => Scale(font, 0.6)
